export default __webpack_public_path__ + "static/media/Shape.7db15e08.svg";